import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import BannerStyleDownloadButton from '../BannerStyleDownloadButton';

import useCreateBlob from '../../app/components/TestResultsDocuments/useCreateBlob.hook';

import {
  downloadNutritionAdviceActionPlan,
  clearDownloadNutritionAdviceActionPlan,
} from '../../app/actions/treatmentPage';

export interface NutritionAdviceActionPlanDownloadButtonProps {
  fileName: string;
  stepId?: string;
  backgroundColor?: string;
  textColor?: string;
  imageUrl?: string;
  imageAlt?: string;
  iconRight?: React.ReactNode;
  title: string;
  subtitle?: string;
  subtitleColor?: string;
  className: string;
  dispatch?: any;
  data?: any;
  error?: boolean;
  type?: string;
}

// TODO: Rename this component because it's no handling only action plan, but also session documentation
const NutritionAdviceActionPlanDownloadButton: React.FC<
  NutritionAdviceActionPlanDownloadButtonProps
> = ({
  dispatch,
  data,
  fileName,
  error,
  stepId,
  backgroundColor,
  textColor,
  imageUrl,
  imageAlt,
  iconRight,
  title,
  subtitle,
  subtitleColor,
  className,
  type,
}) => {
  const { treatmentId } = useParams();
  const { downloadDocument, downloadError } = useCreateBlob(
    data?.blob,
    fileName,
    () => dispatch(clearDownloadNutritionAdviceActionPlan()),
  );

  const downloadActionPlan = () => {
    dispatch(downloadNutritionAdviceActionPlan(treatmentId, stepId, type));
  };

  useEffect(() => {
    if (
      data &&
      data.stepId === stepId &&
      data.buttonType === type &&
      data.blob
    ) {
      downloadDocument();
    }
  }, [data, stepId, type, downloadDocument]);

  const hasError =
    error &&
    data?.stepId === stepId &&
    data?.buttonType === type &&
    !data?.blob;

  return (
    <BannerStyleDownloadButton
      backgroundColor={backgroundColor}
      textColor={textColor}
      imageUrl={imageUrl}
      imageAlt={imageAlt}
      iconRight={iconRight}
      title={title}
      subtitle={subtitle}
      subtitleColor={subtitleColor}
      onClick={() => downloadActionPlan()}
      error={hasError || downloadError}
      className={className}
    />
  );
};

const mapStateToProps = (state: any) => ({
  data: state.treatmentPage.get('downloadNutritionAdviceActionPlanData'),
  error: state.treatmentPage.get('downloadNutritionAdviceActionPlanError'),
});

export default connect(mapStateToProps)(
  NutritionAdviceActionPlanDownloadButton,
);
